import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { withRouter } from "react-router-dom";
import { Header } from "@cars24/turbo-web/lib/header";
import { NUMBER } from "../../../constants/app-constants";

const FloatingBackButton = ({ visible, onClick }) => (
    <div
        styleName={`${"styles.floatingBackButton"} ${visible ? "styles.visible" : "styles.hidden"}`}
        onClick={onClick}
    >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 12H5M12 19L5 12L12 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </div>
);

FloatingBackButton.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

// Scroll-triggered Header Component for webview - customziable
export const HeaderWebView = ({ triggerElementRef = null, triggerElementId = "", title = "", onBack }) => {
    const [showFloatingButton, setShowFloatingButton] = useState(false);
    const refBasedOnDomElementId = useRef(null);

    const handleBackClick = () => {
        if (typeof window === "undefined") return;
        if (typeof onBack === "function") {
            onBack();
            return;
        }
        if (window.history.length > NUMBER.ONE) {
            window.history.back();
            return;
        }
        const message = JSON.stringify({ eventAction: "goBack" });
        if (window?.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(message);
        }
    };

    useEffect(() => {
        // Initialize the ref with the DOM element after component mounts
        if (typeof window !== "undefined" && !triggerElementRef && triggerElementId) {
            refBasedOnDomElementId.current = document.getElementById(triggerElementId);
            if (!refBasedOnDomElementId.current) setShowFloatingButton(true);
        } else if (triggerElementRef.current) {
            refBasedOnDomElementId.current = triggerElementRef?.current;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const headerArgs = {
        variant: "primary",
        size: "medium",
        sticky: true,
        shadow: false,
        border: true,
        transparent: false,
        intersectionWatcher: {
            targets: [
                {
                    id: "header-trigger-section",
                    ref: refBasedOnDomElementId,
                    onEnter: () => {
                        setShowFloatingButton(false);
                    },
                    onExit: () => {
                        setShowFloatingButton(true);
                    },
                    transitions: [
                        // {
                        //   property: "transform",
                        //   from: "translateY(-100%)",
                        //   to: "translateY(0)",
                        //   duration: "0.4s",
                        //   easing: "cubic-bezier(0.4, 0, 0.2, 1)",
                        // },
                        // {
                        //   property: "opacity",
                        //   from: "0",
                        //   to: "1",
                        //   duration: "0.3s",
                        //   easing: "ease-in-out",
                        // },
                    ]
                }
            ],
            observerConfig: {
                threshold: 0.1,
                rootMargin: "0px 0px -90% 0px",
                triggerOnce: false
            }
        }
        // style: {
        //   transform: "translateY(-100%)",
        //   opacity: "0",
        // },
    };

    return (
        <Header {...headerArgs}>
            <Header.Left>
                <FloatingBackButton visible={true} onClick={handleBackClick} />
                {
                    showFloatingButton &&
                    <span styleName={"styles.headerTitle"}>{title}</span>
                }
            </Header.Left>
        </Header>
    );
};

HeaderWebView.propTypes = {
    triggerElementRef: PropTypes.object,
    triggerElementId: PropTypes.string,
    title: PropTypes.string,
    onBack: PropTypes.func
};

export default withRouter(HeaderWebView);
